// import React, { useEffect, useState } from "react";
// import useBroadcasts from "../../redux/broadcasts/broadcastsAction";
// import styles from "./index.module.scss";

// var broadcastMsgs = [];
// var broadcastMsgIndex = 0;
// var hdlUpdateBroadcast = null;
// var iColorIndex = 0;
// var msgContent = null;
// function BroadcastPanel() {
//   const { broadcasts, bonusBroadcast } = useBroadcasts();
//   const [isUpdating, setIsUpdating] = useState(false);

//   //===========================================================================
//   useEffect(() => {
//     componentDidMount();
//     return componentWillUnmount;
//   }, []);

//   useEffect(() => {
//     if ((broadcasts || bonusBroadcast) && !isUpdating) {
//       // reset broadcasts
//       setIsUpdating(true);
//       broadcastMsgs = [];

//       if (broadcasts.length > 0) {
//         for (var i = 0; i < broadcasts.length; i++) {
//           const id = broadcasts[i].id;
//           const text = broadcasts[i].content;
//           //const marqueeLife = broadcasts[i].content.length / 8 + 7;
//           const marqueeLife = broadcasts[i].content.length;
//           broadcastMsgs.push({
//             id: id,
//             content: text,
//             life: marqueeLife,
//           });
//         }
//       }

//       if (bonusBroadcast.length > 0) {
//         for (var i = 0; i < bonusBroadcast.length; i++) {
//           const text = bonusBroadcast[i].Content;
//           //const marqueeLife = text.length / 8 + 7;
//           const marqueeLife = text.length;
//           broadcastMsgs.push({
//             id: bonusBroadcast[i]._id,
//             content: text,
//             life: marqueeLife,
//           });
//         }
//       }

//       if (hdlUpdateBroadcast) clearTimeout(hdlUpdateBroadcast);
//       hdlUpdateBroadcast = setTimeout(() => {
//         showNextBroadcastMsg();
//       }, 1000);
//       setIsUpdating(false);
//     }
//   }, [broadcasts, bonusBroadcast, isUpdating]);
//   //===========================================================================

//   function componentDidMount() {}

//   function componentDidUpdate() {}

//   function componentWillUnmount() {
//     if (hdlUpdateBroadcast) {
//       clearTimeout(hdlUpdateBroadcast);
//       hdlUpdateBroadcast = null;
//     }
//   }

//   function showNextBroadcastMsg() {
//     const uiBroadcastMsg = document.getElementById("broadcastMsg");
//     if (broadcastMsgs.length > 0) {
//       uiBroadcastMsg.style.opacity = 1.0;
//       //uiBroadcastMsg.behavior = scroll;
//       switch (iColorIndex) {
//         case 0:
//           iColorIndex++;
//           uiBroadcastMsg.style.textShadow = "0 0 0.2em #F87, 0 0 0.2em #F87";
//           break;

//         case 1:
//           iColorIndex++;
//           uiBroadcastMsg.style.textShadow =
//             "0 0 0.2em #87F, 0 0 0.2em #87F,0 0 0.2em #87F";
//           break;

//         case 2:
//           iColorIndex = 0;
//           uiBroadcastMsg.style.textShadow = "0 0 0.2em #8F7, 0 0 0.2em #8F7";

//           break;

//         default:
//           iColorIndex = 0;
//           uiBroadcastMsg.style.textShadow = "0 0 0.2em #8F7, 0 0 0.2em #8F7";
//           break;
//       }

//       uiBroadcastMsg.style.fontSize = "28px";
//       uiBroadcastMsg.style.fontWeight = "bold";

//       broadcastMsgIndex = (broadcastMsgIndex + 1) % broadcastMsgs.length;

//       msgContent = broadcastMsgs[broadcastMsgIndex].content;

//       // trigger next msg
//       hdlUpdateBroadcast = setTimeout(() => {
//         showNextBroadcastMsg();
//       }, broadcastMsgs[broadcastMsgIndex].life * 1000);
//     } else {
//       uiBroadcastMsg.style.opacity = 0.3;
//       broadcastMsgIndex = 0;
//     }

//     if (uiBroadcastMsg) {
//       uiBroadcastMsg.innerText = "";
//       var element = msgContent
//         ? document.createElement("marquee")
//         : document.createElement("div");
//       element.innerText = msgContent ? msgContent : "公告...";
//       uiBroadcastMsg.appendChild(element);
//       //uiBroadcastMsg.scrollAmount = 0;
//       //element.behavior = scroll;
//       //element.scrollAmount = 0;
//     }
//   }

//   function render() {
//     return <div id="broadcastMsg" className={styles.broadcastPanel}></div>;
//   }

//   return render();
// }

// export default BroadcastPanel;

import React, { useEffect, useRef, useState } from "react";
import useBroadcasts from "../../redux/broadcasts/broadcastsAction";
import styles from "./index.module.scss";

const SPEED = 65; // px/sec
const BUFFER = 30; // 安全距離px

function BroadcastPanel() {
  const { broadcasts, bonusBroadcast } = useBroadcasts();
  const [broadcastMsgs, setBroadcastMsgs] = useState([]);
  const [curIndex, setCurIndex] = useState(0);
  const [showMsg, setShowMsg] = useState(""); // 先 render 新字串
  const [animKey, setAnimKey] = useState(0);
  const [animInfo, setAnimInfo] = useState({});

  const panelRef = useRef(null);
  const textRef = useRef(null);

  // 更新廣播內容
  useEffect(() => {
    const arr = [];
    if (broadcasts?.length)
      broadcasts.forEach((b) => arr.push({ id: b.id, content: b.content }));
    if (bonusBroadcast?.length)
      bonusBroadcast.forEach((b) => arr.push({ id: b._id, content: b.Content }));
    setBroadcastMsgs(arr);
    setCurIndex(0);
    setAnimKey((k) => k + 1);
  }, [broadcasts, bonusBroadcast]);

  // 1. 切換訊息時先 render 新內容
  useEffect(() => {
    if (broadcastMsgs.length > 0) setShowMsg(broadcastMsgs[curIndex].content);
  }, [broadcastMsgs, curIndex]);

  // 2. 新內容 render 後再量寬度
  useEffect(() => {
    if (!panelRef.current || !textRef.current || !showMsg) return;
    const panelWidth = panelRef.current.offsetWidth;
    const textWidth = textRef.current.offsetWidth;
    const totalDistance = panelWidth + textWidth + BUFFER;
    const duration = totalDistance / SPEED; // 秒
    const animationName = `marquee-move-${animKey}`;
    setAnimInfo({
      animationName,
      duration,
      panelWidth,
      textWidth,
      keyframes: `
        @keyframes ${animationName} {
          from { transform: translateX(${panelWidth}px);}
          to   { transform: translateX(-${textWidth + BUFFER}px);}
        }
      `
    });
  }, [showMsg, animKey]);

  // 切換下一則
  const goNext = () => {
    setCurIndex((idx) => (idx + 1) % broadcastMsgs.length);
    setAnimKey((k) => k + 1);
  };

  // 動態色彩
  const colorShadows = [
    "0 0 0.2em #F87, 0 0 0.2em #F87",
    "0 0 0.2em #87F, 0 0 0.2em #87F,0 0 0.2em #87F",
    "0 0 0.2em #8F7, 0 0 0.2em #8F7",
  ];
  const colorIndex = curIndex % colorShadows.length;

  return (
    <div className={styles.broadcastPanel} ref={panelRef} style={{overflow:"hidden", position:"relative"}}>
      <style>{animInfo.keyframes}</style>
      {showMsg ? (
        <div
          ref={textRef}
          className={styles.marqueeText}
          key={animKey}
          style={{
            animation: `${animInfo.animationName} ${animInfo.duration}s linear forwards`,
            textShadow: colorShadows[colorIndex],
            fontSize: "28px",
            fontWeight: "bold",
            color: "white",
            height: "100%",
            display: "flex",
            alignItems: "center",
            position: "absolute",
            left: 0,
            top: 0,
            whiteSpace: "nowrap"
          }}
          onAnimationEnd={goNext}
        >
          {showMsg}
        </div>
      ) : (
        <div style={{ color: "#ccc", lineHeight: "30px" }}>公告...</div>
      )}
    </div>
  );
}

export default BroadcastPanel;
